import React from "react";
import { Icon } from "@iconify/react";

const Badge = (props) => {
  return (
    <div className="flex items-center space-x-2 w-fit rounded-[45px] bg-[rgba(0,187,221,0.10)] py-[10px] px-[22px]">
      <Icon color="#00BBDD" icon="mdi:sparkles" width={16} height={16} />
      <span className="small font-manrope font-bold uppercase light-blue-color ">
        {props.txt}
      </span>
    </div>
  );
};

export default Badge;
